<template>
    <v-tooltip class="tooltip">
        <slot />
        <span class="tooltiptext">{{ $trans(title) }}</span>
    </v-tooltip>
</template>

<script>
import vTooltip from "floating-vue";
import "floating-vue/dist/style.css";

export default {
    props: {
        title: String
    },
    components: {
        vTooltip
    }
};
</script>

<style lang="scss" scoped>
.tooltip {
    position: relative;
    display: inline-block;
    z-index: 2;
    fill: var(--white, #fff);
    filter: drop-shadow(
            0px 20.6842098236084px 46.884212493896484px rgba(29, 36, 55, 0.2)
        )
        drop-shadow(
            0px -1.378947377204895px 15.168420791625977px rgba(29, 36, 55, 0.2)
        );
}

.tooltip .tooltiptext {
    position: absolute;

    visibility: hidden;
    width: 300px;
    background-color: $white;

    color: $black;
    padding: 10px;
    z-index: 10;
    top: 190%;
    margin-right: -15px;
    font-size: 14px;
    font-weight: 400;
    margin-left: -60px;

    @media (max-width: $tablet) {
        left: 100%;
        transform: (translateX(-35%));
        margin-left: 0;
    }
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    right: 15px;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent $white transparent;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>
